import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=4e18d5ca&"
import script from "./FooterApp.vue?vue&type=script&lang=ts&"
export * from "./FooterApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports